const HOOK_SETUP = "devtools-plugin:setup";
const HOOK_PLUGIN_SETTINGS_SET = "plugin:settings:set";
export {
  HOOK_PLUGIN_SETTINGS_SET,
  HOOK_SETUP
};
//# sourceMappingURL=const.mjs.map
